export const ACCEPTED_FILE_TYPES = ['.csv', '.xlsx', '.xls']